var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M4 18l2-4h5.153a1 1 0 0 0 .986-.836L12.5 11h-6a.5.5 0 1 1 0-1h6.167L13 8a.592.592 0 0 1 .852.608l-.62 4.656A2 2 0 0 1 11.248 15H6.56l-2.14 4H2v-1h2zm3.465-.496a.374.374 0 0 1 .35-.504c.312 0 .593.184.717.47.03.066.056.124.08.172a6 6 0 1 0 7.345-8.316 5.607 5.607 0 0 0-.474-.134.633.633 0 0 1-.483-.615.417.417 0 0 1 .503-.408c.212.045.382.086.511.125a7 7 0 1 1-8.55 9.21zM12 3a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1zm0-1a2 2 0 0 1 2 2v1a2 2 0 1 1-4 0V4a2 2 0 0 1 2-2z" })
  );
});